export const STOCK_STATUS_ALL = 'ALL';
export const STOCK_STATUS_ENOUGH = 'ENOUGH';
export const STOCK_STATUS_EMPTY = 'EMPTY';
export const STOCK_STATUS_NEGATIVE = 'NEGATIVE';

export const STOCK_STATUS_OPTIONS = [
  { value: STOCK_STATUS_ALL, label: 'ทั้งหมด' },
  { value: STOCK_STATUS_ENOUGH, label: 'พอ' },
  { value: STOCK_STATUS_EMPTY, label: 'หมด' },
  { value: STOCK_STATUS_NEGATIVE, label: 'ติดลบ' },
];

export const MOBILE_MODEL_ALL = 'ALL';

/** ตัดสินสถานะสต็อกของ 1 แถวจาก effectiveAvailableQty เทียบกับ 0 */
export const matchStockStatus = (effectiveAvailableQty, status) => {
  switch (status) {
    case STOCK_STATUS_ENOUGH:
      return effectiveAvailableQty > 0;
    case STOCK_STATUS_EMPTY:
      return effectiveAvailableQty === 0;
    case STOCK_STATUS_NEGATIVE:
      return effectiveAvailableQty < 0;
    default:
      return true;
  }
};
